import { ReactElement } from 'react'
import { useUserData } from 'lib/hooks'
import { Header, HeaderProps } from '@/components/patterns/Header'
import { Footer, FooterProps } from '@/components/patterns/Footer'
import { Container } from '@/components/utils'
import { auth } from '../lib/firebase'

export const GlobalStyles: React.FC = ({ children }) => (
  <div className="text-navy-900 antialiased">{children}</div>
)
export function AdminLayout({ children }): ReactElement {
  const [userInfo] = useUserData()

  const header: HeaderProps = {
    pages: [
      { title: 'Panell de control', url: '/admin' },
      {
        title: 'Desconnectar-se',
        url: '/',
        action: () => {
          auth.signOut()
        },
      },
    ],
  }
  const footer: FooterProps = {
    promoters: {
      groups: [],
    },
    links: [
      { title: 'Contacte', url: '/contacte' },
      { title: 'Avís legal', url: '/avis-legal' },
      { title: 'Política de privacitat', url: '/politica-de-privacitat' },
      { title: 'Política de cookies', url: '/politica-de-cookies' },
      { title: 'Admin', url: '/admin' },
    ],
    instagramUrl: 'https://www.instagram.com/omniumcultural/',
    facebookUrl: 'https://www.facebook.com/omniumcultural/',
    twitterUrl: 'https://twitter.com/omnium',
    telegramUrl: 'https://t.me/omnium',
    youtubeUrl: 'https://www.youtube.com/user/omniumcultural',
    phone: '93 319 80 50',
    email: 'cinexic@omnium.cat',
    address:
      "Seu Nacional d'Òmnium Cultural Diputació, 276, pral. 08009 Barcelona",
    copyright: '© 2021 Cinexic. Tots els drets reservats.',
    signupUrl:
      'https://fes-te-soci.omnium.cat/?utm_source=cinexic.cat&utm_medium=referral&utm_campaign=cinexic',
    signupText: "Fes-te soci d'Òmnium",
  }

  if (!userInfo) return null

  return (
    <>
      <GlobalStyles>
        <Container>
          <div className="flex flex-col min-h-full">
            <Header {...header} />
            <main className="flex-1">{children}</main>
            <Footer {...footer} />
          </div>
        </Container>
      </GlobalStyles>
    </>
  )
}
